import React from 'react';

import { Tooltip, TooltipContent, TooltipTrigger } from '@eluve/components';

export interface TenantBundleBlocker {
  bundleId: string;
  bundleDisplayName: string | null;
}

export interface BundleBlockerTooltipProps {
  blockedBy: TenantBundleBlocker[];
  /** The Switch/Button etc. the user would otherwise interact with. */
  children: React.ReactNode;
}

/**
 * Wraps a disabled toggle so hovering it surfaces the bundles that are
 * holding it in the enabled state. Used by both the tenant prompt-template
 * and tenant output-template tables.
 */
export const BundleBlockerTooltip: React.FC<BundleBlockerTooltipProps> = ({
  blockedBy,
  children,
}) => (
  <Tooltip>
    <TooltipTrigger asChild>
      {/* span wraps the disabled control so it still receives hover events */}
      <span tabIndex={0}>{children}</span>
    </TooltipTrigger>
    <TooltipContent>
      <div>Disable the following tenant bundles before deactivating this:</div>
      <ul className="mt-1 list-disc pl-4">
        {blockedBy.map((b) => (
          <li key={b.bundleId}>{b.bundleDisplayName ?? b.bundleId}</li>
        ))}
      </ul>
    </TooltipContent>
  </Tooltip>
);
